import { createBrowserRouter } from "react-router-dom";
import About from "../components/About/About";
import Blogs from "../components/Blogs/Blogs";
import ErrorPage from "../components/ErrorPage/ErrorPage";
import Layout from "../components/Layout/Layout";
import SingleQuiz from "../components/SingleQuiz/SingleQuiz";
import Statistics from "../components/Statistics/Statistics";
import Home from "../components/Home/Home";

const router = createBrowserRouter([
    {
        path: '/',
        loader: async () => fetch('https://openapi.programming-hero.com/api/quiz'),
        errorElement: <ErrorPage></ErrorPage>,
        element: <Layout></Layout>,
        children: [
            { path: '/', element: <Home></Home> },
            { path: '/home', element: <Home></Home> },
            { path: '/statistics', element: <Statistics></Statistics> },
            { path: '/blogs', element: <Blogs></Blogs> },
            { path: '/about', element: <About></About> },
            {
                path: '/home/:id',
                loader: async ({ params }) => fetch(`https://openapi.programming-hero.com/api/quiz/${params.id}`),
                element: <SingleQuiz></SingleQuiz>
            }
        ]
    }
]);

export default router;